import React from 'react';
import { Route } from 'react-router-dom';
import LocationsPageRoute from './LocationsPageRoute';

const basePath = '/v2/locations';

export default (
  <Route path={basePath}>
    <Route exact path={basePath}>
      <LocationsPageRoute />
    </Route>
  </Route>
);
